import Vue from 'vue'
import VueRouter from 'vue-router'
import Welcome from '../views/Welcome.vue'
import Login from '../views/auth/Login.vue'
import Register from '../views/auth/Register.vue'
import Dashboard from '../views/Dashboard.vue'
import Victims from '../views/Victims.vue'
import Settings from '../views/Settings.vue'

//Private Scamas
import prvCreate from '../views/privateScamas/Create.vue'
import prvEdit from '../views/privateScamas/Edit.vue'
import prvIndex from '../views/privateScamas/Index.vue'
import i18n from '../i18n'
import store from '@/store/index'


Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    redirect: `/${i18n.locale}`
  },
  {
    path:'/:lang',
    component : {
      render(c) { return c('router-view')}
    },
    children : [
      {
        path: '/',
        name: 'Welcome',
        component: Welcome,
        meta: {guestOnly: true}
      },
      {
        path: 'login',
        name: 'Login',
        component: Login,
        meta: {guestOnly: true}
      },
      {
        path: 'register',
        name: 'Register',
        component: Register,
        meta: {guestOnly: true}
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: {authOnly: true}
      },
      {
        path: 'victims',
        name: 'Victims',
        component: Victims,
        meta: {authOnly: true}
      },
      {
        path: 'settings',
        name: 'Settings',
        component: Settings,
        meta: {authOnly: true}
      },

      {
        path: 'private',
        component : {
          render(c) { return c('router-view')}
        },
        meta: {authOnly: true},

        children: [
         {
          path: 'create',
          name: 'prvCreate',
          component: prvCreate,
         },
         {
          path: 'edit/:id',
          name: 'prvEdit',
          component: prvEdit,
         },
         {
          path: 'index',
          name: 'prvIndex',
          component: prvIndex,
         },
        ]
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters['auth/authenticated'];

  //authOnly
  if (to.matched.some(record => record.meta.authOnly)) {
    if (!isAuthenticated) {
      next({name: 'Login'})
    } else {
      next()
    }
  }

  //GuestOnly
  else if (to.matched.some(record => record.meta.guestOnly)) {
    if (isAuthenticated) {
      next({name: 'Dashboard'})
    } else {
      next()
    }
  }

  else {
    next()
  }
})

export default router
